import config from 'config/config';

const lang = config.app.defaultLanguage;

export default (values, fields, message) =>
    fields.reduce(
        (errors, field) => {
            if (!values?.[lang]?.[field]) {
                errors[lang][field] = message;
            }
            return errors;
        },
        { [lang]: {} },
    );
